import actionTypes from "consts/actionTypes.js";

const initialState = {
  user: {
    loading: false,
    data: undefined,
    error: undefined,
  },
  component_quizz: {
    loading: false,
    data: undefined,
    error: undefined,
  },
  update: {
    loading: false,
    data: undefined,
    error: undefined,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLEAN_CGN:
      return initialState;
    // USER APPOINTMENTS
    case actionTypes.GET_CGN_PENDING:
      return {
        ...state,
        user: {
          loading: true,
          error: undefined, // Empty error for retry
        },
      };
    case actionTypes.GET_CGN_SUCCESS:
      if (action.payload.status) {
        return {
          ...state,
          user: {
            loading: false,
            data: action.payload.result,
          },
        };
      } else {
        return {
          ...state,
          user: {
            loading: false,
            error: action.payload.error,
          },
        };
      }
    case actionTypes.GET_CGN_ERROR:
      return {
        ...state,
        user: {
          loading: false,
          error: action.error,
        },
      };
    case actionTypes.COMPONENT_QUIZZ_CGN_PENDING:
      return {
        ...state,
        component_quizz: {
          loading: true,
          error: undefined, // Empty error for retry
        },
      };
    case actionTypes.COMPONENT_QUIZZ_CGN_SUCCESS:
      if (action.payload.status) {
        return {
          ...state,
          component_quizz: {
            loading: false,
            data: action.payload.result.quizz,
          },
        };
      } else {
        return {
          ...state,
          component_quizz: {
            loading: false,
            error: action.payload.error,
          },
        };
      }
    case actionTypes.COMPONENT_QUIZZ_CGN_ERROR:
      return {
        ...state,
        component_quizz: {
          loading: false,
          error: action.error,
        },
      };
    case actionTypes.POST_UPDATE_CGN_PENDING:
      return {
        ...state,
        update: {
          loading: true,
        },
      };
    case actionTypes.POST_UPDATE_CGN_SUCCESS:
      if (action.payload.status) {
        return {
          ...state,
          update: {
            loading: false,
            data: action.payload.result,
          },
        };
      } else {
        return {
          ...state,
          update: {
            loading: false,
            error: action.payload.error,
          },
        };
      }
    case actionTypes.POST_UPDATE_CGN_ERROR:
      return {
        ...state,
        update: {
          loading: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/cgn.js